import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as MentorSVG } from './assets/mentor.svg';
import useStyles from './styles';

const MentorAvatar = ({ imageSrc, name }: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box className={classes.mentorWrapper}>
      {imageSrc ? (
        <img alt="Mentor" className={classes.mentorImage} src={imageSrc} />
      ) : (
        <MentorSVG className={classes.mentorImage} />
      )}
      <Box className={classes.mentorTitleSection}>
        <Typography className={classes.label} variant="body1">
          {name}
        </Typography>
        <Typography className={classes.yourHostLabel} variant="body1">
          {t('v2.global.label_yourHost')}
        </Typography>
      </Box>
    </Box>
  );
};

export default MentorAvatar;
